import sumValues from './sum-values';

export default function mergeWriteIns (candidates) {
  const writeIns = candidates.filter((candidate) => candidate.party === 'writein');
  const writeInsTotalVotes = sumValues(writeIns, 'votes');
  const merged = candidates.filter((candidate) => candidate.party !== 'writein');

  merged.push({
    id: 9999,
    ballot_name: 'Write-in candidates',
    ballot_last_name: 'Write-ins',
    incumbent: false,
    winner: false,
    votes: writeInsTotalVotes,
    party: 'writein'
  });

  return merged;
}



// WEBPACK FOOTER //
// ./utils/merge-write-ins.js